import React, { createContext, useEffect, useReducer } from "react";
import reducer from "./reducer";
import { firebase } from "./firebase/firebase.utils";

const initialState = {
  user: null,
  userFullInformation: null,
  error: null,
  showLogin: false,
  isLoading: true,
};

export const Context = createContext(initialState);

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (firebase.apps.length && firebase) {
      firebase
        .app()
        .auth()
        .onAuthStateChanged((user) => {

          if (!user?.isAnonymous)
            addUser(user);
          setLoading(false);
        });
    }
  }, []);

  function setLoading(isLoading) {
    dispatch({
      type: "SET_LOADING",
      payload: isLoading,
    });
  }

  function addUser(user) {
    dispatch({
      type: "SET_CURRENT_USER",
      payload: user,
    });
  }

  function addUserInformation(user) {
    dispatch({
      type: "SET_CURRENT_USER_ME",
      payload: user,
    });
  }

  function removeUserInformation() {
    dispatch({
      type: "REMOVE_CURRENT_USER_ME",
    });
  }

  function removeUser() {
    localStorage?.removeItem("user");
    localStorage?.removeItem("token");
    dispatch({
      type: "REMOVE_CURRENT_USER",
    });
  }
  function updatePaymentStatus(booleanToUse) {
    dispatch({
      type: "SET_PAYMENT_STATUS",
      payload: booleanToUse,
    });
  }

  function showLoginPopup(booleanToUse) {
    dispatch({
      type: "SET_LOGIN_POP_UP",
      payload: booleanToUse,
    });
  }

  function clickedBuyNow(booleanToUse) {
    dispatch({
      type: "SET_CLICKED_BUY_NOW",
      payload: booleanToUse,
    });
  }

  return (
    <Context.Provider
      value={{
        user: state.user,
        userFullInformation: state.userFullInformation,
        paymentStatus: state.paymentStatus,
        isLoading: state.isLoading,
        showLogin: state.showLogin,
        isBuyNowClicked: state.isBuyNowClicked,
        addUser,
        removeUser,
        updatePaymentStatus,
        addUserInformation,
        removeUserInformation,
        clickedBuyNow,
        showLoginPopup,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Store;
